import { SVGProps } from 'react';

const MarkerS = ({
    ...otherProps
}: SVGProps<SVGSVGElement>) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="16" height="16" rx="8" fill="#FF8200" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00019 5.33344C8.49111 5.33344 8.88908 4.93547 8.88908 4.44455C8.88908 3.95363 8.49111 3.55566 8.00019 3.55566C7.50927 3.55566 7.1113 3.95363 7.1113 4.44455C7.1113 4.93547 7.50927 5.33344 8.00019 5.33344ZM7.99997 6.22222C7.50905 6.22222 7.11108 6.62019 7.11108 7.11111V11.5556C7.11108 12.0465 7.50905 12.4444 7.99997 12.4444C8.49089 12.4444 8.88886 12.0465 8.88886 11.5556V7.11111C8.88886 6.62019 8.49089 6.22222 7.99997 6.22222Z" fill="white" />
    </svg>
);

export default MarkerS;

